import React from 'react';
import { IntlProvider } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
import { DEFAULT_LOCALE } from '@atlassian/proforma-common-core/intl-provider';

// eslint-disable-next-line @repo/internal/import/no-import-all
import * as i18nMessagesUntyped from '../../i18n';
const i18nMessages = i18nMessagesUntyped;
const LOCALE_REGEX = /([a-z]+)(?:[-_]([A-Z]+))?/i;
export const PackageIntlProvider = ({
  children,
  locale
}) => {
  let match = LOCALE_REGEX.exec(locale);
  if (!match) {
    // eslint-disable-next-line no-console
    console.error('Unable to get language and country from invalid locale, falling back to default locale.');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    match = LOCALE_REGEX.exec(DEFAULT_LOCALE);
  }
  const [, languagePart, countryPart] = match;
  const language = languagePart.toLowerCase();
  const country = countryPart === null || countryPart === void 0 ? void 0 : countryPart.toUpperCase();
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: country && i18nMessages[`${language}_${country}`] || i18nMessages[language] || i18nMessages[DEFAULT_LOCALE],
    locale: country ? `${language}-${country}` : language,
    defaultLocale: DEFAULT_LOCALE,
    defaultRichTextElements: {
      strong: chunks => /*#__PURE__*/React.createElement(Text, {
        as: "strong"
      }, chunks)
    }
  }, children);
};